module.exports = "/static/assets/8367039032cfd3682ce830aa38dd62ba.png";